import { render, staticRenderFns } from "./CallDetailInfo.vue?vue&type=template&id=2ecf43bc&scoped=true"
import script from "./CallDetailInfo.vue?vue&type=script&lang=js"
export * from "./CallDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./CallDetailInfo.vue?vue&type=style&index=0&id=2ecf43bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf43bc",
  null
  
)

export default component.exports